{
  "page": {
    "title": "Products",
    "add": "Add product",
    "search": "Search products…",
    "active": "Active",
    "inactive": "Inactive",
    "all": "All",
    "allCategories": "All categories",
    "retry": "Retry",
    "empty": "No products yet",
    "name": "Name",
    "category": "Category",
    "price": "Price",
    "status": "Status"
  },
  "editor": {
    "notFound": "Product not found",
    "backToProducts": "Back to products",
    "back": "Back",
    "active": "Active",
    "save": "Save",
    "saved": "Saved.",
    "saveFailed": "Could not save the product.",
    "create": "Create product",
    "created": "Product created.",
    "createFailed": "Could not create the product.",
    "nameRequired": "Enter a product name.",
    "categoryRequired": "Choose a product category.",
    "priceRequired": "Set a price for at least one SKU.",
    "missingName": "product name",
    "missingCategory": "product category",
    "missingPrice": "price for at least one SKU",
    "completeFields": "Complete: {{fields}}",
    "basic": "Basic information",
    "name": "Product name",
    "nameExample": "e.g. Crew-neck T-shirt",
    "productSku": "Product-level SKU",
    "skuFromName": "Generated from the product name",
    "category": "Product category",
    "tags": "Tags",
    "tagsPlaceholder": "Type and press Enter to add",
    "images": "Images",
    "variants": "Variant groups",
    "skuMatrix": "SKUs (price, stock, and cost per option)",
    "newSkuHint": "Set a price and stock for each SKU. Products without options use the “Default” row. Set stock above 0 to make an SKU available for sale.",
    "editSkuHint1": "SKUs come from the variant groups above. Edit price, stock, cost, weight, and availability for each row, then save once to apply.",
    "editSkuHint2": "Set stock above 0 to sell an SKU. At 0, orders cannot be created and the AI assistant reports it as out of stock.",
    "actions": "Actions",
    "confirmVariants": "Confirm variant changes",
    "variantsWillRemove": "Changing variant groups will remove or hide these SKUs:",
    "variantsRemovalDetail": "SKUs without order history are deleted immediately. SKUs referenced by an order are hidden instead.",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "warning": "Warning",
    "obsoleteWarning": "Saving will change the status of {{count}} SKUs that do not match the new variants. Save to review and confirm.",
    "defaultOption": "Default"
  },
  "media": {
    "pending": "Not uploaded",
    "remove": "Remove image",
    "add": "Add image",
    "hint": "Product images (up to {{max}} · 1 MB maximum per file · the first image is the cover)"
  },
  "sku": {
    "empty": "SKUs will be generated when you save. Add variant groups if needed, then save the product.",
    "option": "Option",
    "priceBaht": "Price (THB)",
    "stock": "Stock",
    "stockAria": "Stock quantity",
    "costBaht": "Cost (THB)",
    "weightShort": "Weight (g)",
    "weightAria": "Weight in grams",
    "active": "Active",
    "activeAria": "Make this SKU active",
    "new": "New",
    "retiring": "Will be removed",
    "edited": "Edited"
  },
  "variants": {
    "groupPlaceholder": "Group name, e.g. Colour / Size",
    "maxGroups": "Up to {{count}} variant groups",
    "addGroup": "Add group",
    "maxReached": "Maximum reached ({{count}} groups)",
    "removeGroup": "Remove group",
    "codeGenerated": "Code generated automatically",
    "codeFor": "Code for {{value}}",
    "skuCodeHint": "Code used to generate the SKU",
    "optionPlaceholder": "Add an option, e.g. White / Black",
    "add": "Add"
  },
  "category": {
    "placeholder": "Choose or search product categories (Thai taxonomy)"
  },
  "errors": {
    "load": "Could not load products.",
    "upload": "Upload failed.",
    "unsupportedImage": "This image type is not supported ({{type}}). Use JPG, PNG, WebP, GIF, AVIF, or HEIC.",
    "processImage": "Could not process the image.",
    "saveImage": "Could not save the image."
  }
}
